/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  NFTIVLaunchPadSign721,
  NFTIVLaunchPadSign721Interface,
} from "../../../../@nftiv/launchpad-721/contracts/NFTIVLaunchPadSign721";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
      {
        internalType: "string",
        name: "defaultContractURILink",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
      {
        internalType: "address",
        name: "receiveCommissionAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "commissionPercentage",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "receiveRoyaltyAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "contractOwner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "FailedETHTransfer",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientFunds",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidMintAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidMintAmountPerPeriod",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidMintAmountPerTx",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRoyaltyPercentage",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSignature",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTimestamp",
    type: "error",
  },
  {
    inputs: [],
    name: "UnexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "UnexpectedMintAmount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "BaseURISet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "startId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "NFTMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "COMMISSION_PERCENTAGE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_SUPPLY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RECEIVE_COMMISSION_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SIGNER",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TICKET_HASH_TYPE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mintAmount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "payload",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newBaseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newContractURI",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "setIsPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiveRoyaltyAddress",
        type: "address",
      },
      {
        internalType: "uint96",
        name: "percentage",
        type: "uint96",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "_interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type NFTIVLaunchPadSign721ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NFTIVLaunchPadSign721ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NFTIVLaunchPadSign721__factory extends ContractFactory {
  constructor(...args: NFTIVLaunchPadSign721ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    name: PromiseOrValue<string>,
    symbol: PromiseOrValue<string>,
    uri: PromiseOrValue<string>,
    defaultContractURILink: PromiseOrValue<string>,
    maxSupply: PromiseOrValue<BigNumberish>,
    signer: PromiseOrValue<string>,
    receiveCommissionAddress: PromiseOrValue<string>,
    commissionPercentage: PromiseOrValue<BigNumberish>,
    receiveRoyaltyAddress: PromiseOrValue<string>,
    royaltyPercentage: PromiseOrValue<BigNumberish>,
    contractOwner: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<NFTIVLaunchPadSign721> {
    return super.deploy(
      name,
      symbol,
      uri,
      defaultContractURILink,
      maxSupply,
      signer,
      receiveCommissionAddress,
      commissionPercentage,
      receiveRoyaltyAddress,
      royaltyPercentage,
      contractOwner,
      overrides || {}
    ) as Promise<NFTIVLaunchPadSign721>;
  }
  override getDeployTransaction(
    name: PromiseOrValue<string>,
    symbol: PromiseOrValue<string>,
    uri: PromiseOrValue<string>,
    defaultContractURILink: PromiseOrValue<string>,
    maxSupply: PromiseOrValue<BigNumberish>,
    signer: PromiseOrValue<string>,
    receiveCommissionAddress: PromiseOrValue<string>,
    commissionPercentage: PromiseOrValue<BigNumberish>,
    receiveRoyaltyAddress: PromiseOrValue<string>,
    royaltyPercentage: PromiseOrValue<BigNumberish>,
    contractOwner: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name,
      symbol,
      uri,
      defaultContractURILink,
      maxSupply,
      signer,
      receiveCommissionAddress,
      commissionPercentage,
      receiveRoyaltyAddress,
      royaltyPercentage,
      contractOwner,
      overrides || {}
    );
  }
  override attach(address: string): NFTIVLaunchPadSign721 {
    return super.attach(address) as NFTIVLaunchPadSign721;
  }
  override connect(signer: Signer): NFTIVLaunchPadSign721__factory {
    return super.connect(signer) as NFTIVLaunchPadSign721__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NFTIVLaunchPadSign721Interface {
    return new utils.Interface(_abi) as NFTIVLaunchPadSign721Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTIVLaunchPadSign721 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as NFTIVLaunchPadSign721;
  }
}
